import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { HR } from 'tmt-ui-kit';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { actions as tripActions } from '~/redux/reducers/trip';
import { calculateTripPrice, calculateMultiTierPrice } from '~/utils/helpers';
import { mapMultiTierPricesToDisplay } from '~/utils/trip';
import PriceDetail from './PriceDetail';
import withTrip from './withTrip';

const PriceContainer = styled.div`
  padding-bottom: 16px;
`;

const Text = styled.p`
  margin: 20px 0px !important;
`;

const enhance = connect(
  (state, props) => {
    let { quantity } = state.session.data;
    if (['car_rental', 'souvenir'].includes(props.trip.product_type)) {
      quantity = state.trip.nonTripQuantity;
    }
    return {
      sessionData: state.session.data,
      rates: state.info.exchangeRates,
      pricing: state.trip.pricing,
      isLoadingPricing: state.trip.isLoadingPricing,
      currentSelectedMultiTier: state.trip.selectedMultiTier,
      quantity,
    };
  }, {
    getTripPrice: tripActions.getTripPrice
  }
);

class Pricing extends Component {
  static propTypes = {
    rates: PropTypes.object,
    sessionData: PropTypes.object,
    trip: PropTypes.object,
    getTripPrice: PropTypes.func,
    customize: PropTypes.bool,
    pricing: PropTypes.object,
    isLoadingPricing: PropTypes.bool,
    quantity: PropTypes.number,
    currentSelectedMultiTier: PropTypes.object,
  }

  state = {
    currentQuantity: 0,
    currentChildQuantity: 0,
  }

  componentDidUpdate() {
    this.updateTripPrice();
  }

  updateTripPrice() {
    const { currentQuantity, currentChildQuantity } = this.state;
    const { sessionData, trip, customize, quantity } = this.props;
    const { childQuantity } = sessionData;

    if (!customize && (currentQuantity !== quantity || currentChildQuantity !== childQuantity)) {
      this.setState({
        currentQuantity: quantity,
        currentChildQuantity: childQuantity,
      });
      const selectedOptions = trip.additional_options.find(option => option.type === 'child_price');
      this.props.getTripPrice({
        promo: '',
        quantity,
        trip_id: trip._id,
        ...(selectedOptions ? {
          selected_options: [{
            ...selectedOptions,
            quantity: childQuantity
          }]
        } : {})
      }, true);
    }
  }

  render() {
    const { rates, sessionData, trip, customize, pricing, isLoadingPricing, quantity, currentSelectedMultiTier } = this.props;
    const { currency, childQuantity } = sessionData;
    const isChildEnabled = trip.additional_options && !!trip.additional_options.find(option => option.type === 'child_price');
    const childPrice = isChildEnabled && trip.additional_options.find(option => option.type === 'child_price').price;
    let discountedPrices = [];
    if (trip.full_prices) {
      discountedPrices = trip.full_prices.map(price => price.seasonedDiscountedPerPerson);
    }
    let discountedPrice = 0;
    const tripSelectedMultiTier = trip.multi_tier_prices.map(mapMultiTierPricesToDisplay);
    const selectedMultiTier = currentSelectedMultiTier || tripSelectedMultiTier;
    if (['car_rental', 'souvenir'].includes(trip.product_type)) {
      discountedPrice = calculateTripPrice(discountedPrices, quantity, childPrice, childQuantity);
    } else if (trip.product_type === 'ticket') {
      const selectedTier = selectedMultiTier.find(tier => tier.active);
      discountedPrice = !!selectedTier ? calculateMultiTierPrice(selectedTier) : 0;
    }
    const isShowPriceDetail = (trip.product_type === 'ticket' && discountedPrice > 0)
                              || trip.product_type !== 'ticket';
    if (customize) {
      return null;
    }
    return (
      <PriceContainer>
        {isShowPriceDetail
          ? (
            <Fragment>
              <HR />
              <PriceDetail
                child={{ price: childPrice, quantity: childQuantity }}
                currency={currency}
                isLoadingPricing={isLoadingPricing}
                pricing={pricing}
                quantity={quantity}
                rates={rates}
                total={discountedPrice}
              />
            </Fragment>
          )
          : (
            <Text>Sorry! Service isn&apos;t available on your selected date. Please select other dates.</Text>
          )}
      </PriceContainer>
    );
  }
}

export default withTrip(enhance(Pricing));
